import React from "react";

interface DeleteIconButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  /** Tooltip + accessible label. */
  title?: string;
  /** Show a spinner instead of the trash icon while a delete is in flight. */
  busy?: boolean;
  /** Emphasize the control (e.g. while awaiting a second confirm click). */
  active?: boolean;
}

/**
 * Shared delete control — a red trash (dustbin) icon button used everywhere a
 * blog can be deleted (the editor footer, the blog list cards) so the delete
 * affordance is identical across the app. Uses Material Icons `delete` and the
 * theme danger color, so it reads correctly in both light and dark mode.
 */
export const DeleteIconButton: React.FC<DeleteIconButtonProps> = ({
  onClick,
  disabled = false,
  title = "Delete",
  busy = false,
  active = false,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled || busy}
    title={title}
    aria-label={title}
    className={`inline-flex h-8 w-8 items-center justify-center rounded-lg text-theme-danger transition-colors hover:bg-theme-danger/10 disabled:cursor-not-allowed disabled:opacity-50 ${
      active ? "bg-theme-danger/10 ring-1 ring-theme-danger/40" : ""
    }`}
  >
    {busy ? (
      <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
    ) : (
      <span className="material-icons" style={{ fontSize: 18 }}>
        delete
      </span>
    )}
  </button>
);

export default DeleteIconButton;
